import type { ReactElement } from 'react';

import styles from './RollingMoneyDigits.module.scss';

const ROLL_DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] as const;

const DEFAULT_DIGIT_COUNT = 3;
const MIN_DIGIT_COUNT = 1;
const MAX_DIGIT_COUNT = 12;

function normalizeDigitCount(value: number): number {
  if (!Number.isFinite(value)) {
    return DEFAULT_DIGIT_COUNT;
  }
  const rounded = Math.floor(value);
  return Math.min(MAX_DIGIT_COUNT, Math.max(MIN_DIGIT_COUNT, rounded));
}

export type TRollingMoneyDigitsProps = {
  digitCount?: number;
};

function RollingDigit({ columnIndex }: { columnIndex: number }): ReactElement {
  const durationSec = 1.35 + columnIndex * 0.14;
  const delayMs = columnIndex * 95;

  return (
    <span className={styles.rollDigit}>
      <span
        className={styles.rollDigitStrip}
        style={{
          animationDuration: `${String(durationSec)}s`,
          animationDelay: `${String(delayMs)}ms`,
        }}
      >
        {ROLL_DIGITS.map((d) => (
          <span className={styles.rollDigitCell} key={`a-${String(d)}`}>
            {d}
          </span>
        ))}
        {ROLL_DIGITS.map((d) => (
          <span className={styles.rollDigitCell} key={`b-${String(d)}`}>
            {d}
          </span>
        ))}
      </span>
    </span>
  );
}

export function RollingMoneyDigits({
  digitCount = DEFAULT_DIGIT_COUNT,
}: TRollingMoneyDigitsProps): ReactElement {
  const count = normalizeDigitCount(digitCount);

  return (
    <>
      <span aria-hidden className={styles.currency}>
        $
      </span>
      <span className={styles.rollDigits}>
        {Array.from({ length: count }, (_, columnIndex) => (
          <RollingDigit columnIndex={columnIndex} key={columnIndex} />
        ))}
      </span>
    </>
  );
}
